export default __webpack_public_path__ + "static/media/transcript2.d4f5302c.pdf";